import { render, staticRenderFns } from "./AdminKennelSearchDialog.vue?vue&type=template&id=05420f22"
import script from "./AdminKennelSearchDialog.vue?vue&type=script&lang=ts"
export * from "./AdminKennelSearchDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports